import Vue from 'vue'
import VueRouter from 'vue-router'
import HoVue from '../components/home'
import HomeVue from '../views/home/HomeList.vue'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  // 起始页
  {
    path: '/home',
    component: HoVue,
    redirect: '/home',
    children: [
      // 首页
      {
        path: '/home',
        component: HomeVue,
      },
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/HomeList.vue'),
      },
      // 集采平台
      {
        path: '/purchaseInfo',
        name: 'purchaseInfo',
        component: () => import('../views/home/purchaseInfo.vue'),
      },
      // 关于我们
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('../views/home/aboutUs.vue'),
      },
      // 资讯中心
      {
        path: '/infoCenter',
        name: 'infoCenter',
        component: () => import('../views/home/infoCenter.vue'),
      },
      // 资讯中心详情
      {
        path: '/infoCenterDetail',
        name: 'infoCenterDetail',
        component: () => import('../views/home/infoCenterDetail.vue'),
      },
      // 联系我们
      {
        path: '/telUs',
        name: 'telUs',
        component: () => import('../views/home/telUs.vue'),
      },
      {
        path: '/guide',
        component: () => import('../views/guide/guide.vue'),
      },
    ],
  },
  // 登录页
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
  },
]
const router = new VueRouter({
  routes,
  mode: 'history',
})
// 挂载路由导航守卫1
router.beforeEach((to, from, next) => {
  // 将整个页面滚动条回滚到顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // 如果需要平滑滚动
  })
  // 检查是否登录，跳转到登录页
  const isLogin = localStorage.getItem('token')
  if (!isLogin && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
})
export default router
